import React, { useState } from 'react';

import { Icons } from '@icons/icons';

import { IGuidelineProps } from './Guideline.types';

import Tooltip from '../Tooltip';

import './Guideline.scss';

const Guideline: React.FC<IGuidelineProps> = ({
	guidelineText,
	maxWidth,
	placement = 'top-end',
	iconColor,
	iconHeight,
	iconWidth,
}) => {
	const [isActiveInfoIcon, setIsActiveInfoIcon] = useState(false);

	const handleMouseEnter = () => setIsActiveInfoIcon(true);

	const handleMouseLeave = () => setIsActiveInfoIcon(false);

	return (
		<Tooltip
			content={guidelineText}
			maxWidth={maxWidth}
			placement={placement}
		>
				<span
					className='f5gGuidelineIcon'
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					{Icons.guidelineIcon({
						isActive: isActiveInfoIcon,
						color: iconColor,
						width: iconWidth,
						height: iconHeight,
					})}
				</span>
		</Tooltip>
	);
};

export default Guideline;
